
module.exports = {
    onMount: function() {
        this.autoApplyAfterRedirect(this.el.getAttribute('prefix'), this.el.getAttribute('csrf'));
    },

    /**
     * Emits an event telling follow widgets to auto-apply if the URL has the correct hash format.
     * This is used after coming back from a signin redirect.
     * Looking for hash format like "${prefix}${csrf}${token}"
     * @param {String} prefix - value telling us this hash was created by follow-ebay
     * @param {String} csrf - csrf value generated by follow-ebay on the server
     * @returns {null} - no return value
     */
    autoApplyAfterRedirect: function(prefix, csrf) {
        var hash = window.location.hash;
        if (!hash || !prefix || hash.indexOf(prefix) !== 1) { return; }
        // prefix is good, so remove the hash from the url state
        history.replaceState(null, '', '#');

        // validate the csrf
        var csrfAndToken = hash.substring(prefix.length + 1);
        if (!csrf || csrfAndToken.indexOf(csrf) !== 0) { return; }

        var eventOptions = {
            detail: {
                token: csrfAndToken.substring(csrf.length)
            }
        };

        // csrf is good so emit event to all follow-ebay widgets to see if they should auto-apply
        if (typeof window.CustomEvent === 'function') {
            var dispatcher = function() {
                document.dispatchEvent(new CustomEvent('follow-auto-apply'
                     + eventOptions.detail.token, eventOptions));
                window.removeEventListener('load', dispatcher);
            };
            window.addEventListener('load', dispatcher);
        }
    }
};
